import { CustomShape } from '../models/CustomShape';
import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
} from './Tool';
import { copyWhiteboardContents } from './ToolCopy';

export class ToolCreateCustomShape extends Tool {
  static toolName = 'Save as custom shape';
  static availableWhenLocked = false;
  // Set to `false` otherwise the whiteboard steals focus from the
  // input in CreateCustomShapeNameModal when the modal opens.
  // We want the user to be able to start typing the custom shape
  // name without having to manually focus the input first.
  static shouldRefocusWhiteboardWhenApplied = false;

  static action({ controller, selection }: IToolActionInput) {
    const result = copyWhiteboardContents({ controller, selection });
    if (!result) {
      console.error(
        'copying whiteboard contents unexpectedly returned an undefined result'
      );
      return;
    }

    const { objectsAsJson } = result;
    if (!objectsAsJson) {
      console.error(
        'copied whiteboard unexpectedly returned undefined instead of object JSON'
      );
      return;
    }

    controller.state.customShapeNameModalProps = {
      kind: 'create',
      initialValue: '',
      onClose: newName => {
        controller.state.customShapeNameModalProps = null;
        if (!newName) {
          return;
        }
        const customShape = new CustomShape({
          name: newName,
          objects: objectsAsJson.objects,
        });

        controller.dataStoreCustomShapes.addRecord(customShape);
        controller.actionShowMessage(`Custom shape "${newName}" created`);
      },
    };
  }

  static enabled({ controller }: IToolEnabledInput) {
    return this.available({ controller });
  }

  static available({ controller }: IToolAvailableInput) {
    return (
      !controller.isReadOnly() &&
      !!controller.props.allowUpdate &&
      !!controller.selection
    );
  }
}

export default ToolCreateCustomShape;
